export * from "./accountsettings.constant.js";
export * from "./usermanagement.constant.js";
export * from "./messages.constant.js";
export * from "./groupmanagement.constant.js";
export * from "./flowsettings.constant.js";
export * from "./adminhistory.constant.js";
export * from "./login.constant.js";
export * from "./login.error.constant.js";
export * from "./mysettings.constant.js";
export * from "./notificationsettings.constant.js";
export * from "./directorysync.constant.js";
export * from "./billing.constant.js";
export * from "./account.featuregate.constant.js";
export * from "./regex.js";
export * from "./serviceaccount.constant.js";

export const GENERAL_DATE_TIME_FORMAT = "MMM DD, h:mm a";

export const DEFAULT_FONT = "Inter";
